module.exports = require("./fr-GQ.js");